import { graphql } from 'gatsby'
import React from 'react'

import { signUpToNewsletter } from '@/helpers'
import { Subheading, FormField, Checkbox, ButtonPrimmary, Content } from '@/uikit'

import useContactForm from './useContactForm'

export const ContactForm: React.FC<GatsbyTypes.ContactFormFragment> = ({
    header,
    button_text = '',
    checkbox_text = '',
    input_placeholder,
    lead,
}) => {
    const {
        formState,
        onInputChange,
        onCheckboxChange,
        validate,
        resetErrors,
        displayError,
        setSuccessfulStatus,
        changeSubmittingStatus,
    } = useContactForm()

    async function sendForm() {
        changeSubmittingStatus()
        signUpToNewsletter(formState.email)
            .then(() => {
                setSuccessfulStatus()
                changeSubmittingStatus()
            })
            .catch(() => {
                displayError('submit', 'Error Message')
                changeSubmittingStatus()
            })
    }

    const onSubmit = (event: React.MouseEvent<HTMLFormElement>) => {
        event.preventDefault()
        resetErrors()
        const isValid = validate()

        if (isValid) {
            sendForm()
        }
    }

    const { email, checked, success, submitting, errors } = formState

    return (
        <div className="pt-10 pb-15">
            <Content>
                <div className="flex justify-center items-center flex-col pt-20 px-7.5 pb-25 sm:py-33 rounded-2xl bg-white dark:bg-body-bg1-dm">
                    <div className="max-w-740">
                        <div className="flex justify-center items-start sm:items-center flex-col">
                            <div className="mb-7.5 text-left sm:text-center max-w-280 sm:max-w-full">
                                {header && <Subheading bold>{header}</Subheading>}
                            </div>
                            <div className="w-full sm:max-w-740 text-left sm:text-center max-w-270  sm:mb-23 mb-15 text-black-lighter">
                                <p className="font-inter font-light text-lg text-black-lighter dark:text-text-70-dm">
                                    {lead}
                                </p>
                            </div>
                            <form className=" max-w-450" onSubmit={onSubmit}>
                                <div className="flex justify-between mb-8">
                                    <div className="ani ani-mask-right w-full sm:max-w-290">
                                        <FormField
                                            placeholder={input_placeholder}
                                            onChange={onInputChange}
                                            value={email}
                                            id="contact-form-email"
                                            error={errors.email}
                                        />
                                    </div>
                                    <div className="w-auto min-w-130 sm:block hidden">
                                        <ButtonPrimmary type="submit" disabled={submitting} hasArrow={false}>
                                            {button_text}
                                        </ButtonPrimmary>
                                    </div>
                                </div>
                                <div className="max-w-450">
                                    <Checkbox
                                        id="contact-form-newsletter_checkbox"
                                        onChange={onCheckboxChange}
                                        value={checked}
                                        error={errors.checkbox}
                                        name="newsletter_checkbox"
                                    >
                                        {checkbox_text}
                                    </Checkbox>
                                </div>
                                <div className="block w-full sm:hidden mt-7.5">
                                    <ButtonPrimmary type="submit" disabled={submitting}>
                                        {button_text}
                                    </ButtonPrimmary>
                                </div>
                                {errors.submit && (
                                    <p className="pl-4 mt-4 font-inter font-normal text-red text-xs text-opacity-50">
                                        {errors.submit}
                                    </p>
                                )}
                                {success && (
                                    <p className="font-inter text-text-70 dark:text-text-70-dm mt-5">
                                        Thank you for submitting the form!
                                    </p>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </Content>
        </div>
    )
}

export const ContactFormQuery = graphql`
    fragment ContactForm on MarkdownRemarkFrontmatterBody {
        header
        lead
        button_text
        checkbox_text
        input_placeholder
    }
`
